import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ToasterService } from '../../services/toaster.service';
import { TranslateService } from '@ngx-translate/core';

export const AuthGuardFxn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const toasterService = inject(ToasterService);
  const translateService = inject(TranslateService);

  if (state.url.includes('/auth/login')) {
    if (authService.isAuthenticated() && window.top === window.self) {
      router.navigate(['/dashboard']);
      return false;
    }
    return true;
  } else {
    if (window.top !== window.self) {
      if (state.url.includes('/auth/login?isIFrame=true')) {
        router.navigateByUrl('/auth/login?isIFrame=true');
      } else if (state.url.includes('auth/signup?isIFrame=true')) {
        router.navigateByUrl('/auth/signup?isIFrame=true');
      }
      return false;
    }
    if (!authService.isAuthenticated()) {
      router.navigate(['/auth/login']);
      toasterService.infoToastr(translateService.instant('LoginFirst'));
      return false;
    }
    return true;
  }
};
